module.exports = __webpack_public_path__ + "static/04-stress-classification-f11f749ae6554ca2143550da01158372.png";